var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TrashSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 1.9375H5.5C5.38397 1.9375 5.27269 1.89141 5.19064 1.80936C5.10859 1.72731 5.0625 1.61603 5.0625 1.5C5.0625 1.38397 5.10859 1.27269 5.19064 1.19064C5.27269 1.10859 5.38397 1.0625 5.5 1.0625H10.5C10.616 1.0625 10.7273 1.10859 10.8094 1.19064C10.8914 1.27269 10.9375 1.38397 10.9375 1.5C10.9375 1.61603 10.8914 1.72731 10.8094 1.80936C10.7273 1.89141 10.616 1.9375 10.5 1.9375Z",
    fill: "#AF0000",
    stroke: "#AF0000",
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.0625 4V3.9375H3H2.5C2.38397 3.9375 2.27269 3.89141 2.19064 3.80936C2.10859 3.72731 2.0625 3.61603 2.0625 3.5C2.0625 3.38397 2.10859 3.27269 2.19064 3.19064C2.27269 3.10859 2.38397 3.0625 2.5 3.0625H13.5C13.616 3.0625 13.7273 3.10859 13.8094 3.19064C13.8914 3.27269 13.9375 3.38397 13.9375 3.5C13.9375 3.61603 13.8914 3.72731 13.8094 3.80936C13.7273 3.89141 13.616 3.9375 13.5 3.9375H13H12.9375V4V12.9999C12.9373 13.2485 12.8384 13.4868 12.6626 13.6626C12.4868 13.8384 12.2485 13.9373 11.9999 13.9375H4.00006C3.75148 13.9373 3.51315 13.8384 3.33738 13.6626C3.1616 13.4868 3.06275 13.2485 3.0625 12.9999V4ZM6.89775 10.8977C7.00324 10.7923 7.0625 10.6492 7.0625 10.5V6.5C7.0625 6.35082 7.00324 6.20774 6.89775 6.10225C6.79226 5.99676 6.64918 5.9375 6.5 5.9375C6.35082 5.9375 6.20774 5.99676 6.10225 6.10225C5.99676 6.20774 5.9375 6.35082 5.9375 6.5V10.5C5.9375 10.6492 5.99676 10.7923 6.10225 10.8977C6.20774 11.0032 6.35082 11.0625 6.5 11.0625C6.64918 11.0625 6.79226 11.0032 6.89775 10.8977ZM9.89775 10.8977C10.0032 10.7923 10.0625 10.6492 10.0625 10.5V6.5C10.0625 6.35082 10.0032 6.20774 9.89775 6.10225C9.79226 5.99676 9.64918 5.9375 9.5 5.9375C9.35082 5.9375 9.20774 5.99676 9.10225 6.10225C8.99676 6.20774 8.9375 6.35082 8.9375 6.5V10.5C8.9375 10.6492 8.99676 10.7923 9.10225 10.8977C9.20774 11.0032 9.35082 11.0625 9.5 11.0625C9.64918 11.0625 9.79226 11.0032 9.89775 10.8977Z",
    fill: "#AF0000",
    stroke: "#AF0000",
    strokeWidth: 0.125
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash-red.9cb20fbf394e312f5c9a21c4b527c724.svg";
export { ForwardRef as ReactComponent };